/* GLZN account, interactie. Config uit data-attributen op #glzn-acc en uit #glzn-melding-data. */
(function(){
  var root=document.getElementById('glzn-acc'); if(!root) return;
  var CFG=root.dataset;
  var B2B=CFG.b2b==='true';
  var MELD_URL='', LOGO_URL='', PREVIEW_URL='';
  var CONTACT_URL='https://glazen.nl/pages/contact';
  var EMAIL=CFG.email||'', NAAM='';
  var WERKDAGEN=3, TRANSIT=1, VERZEND=6.95, FOTO_VERPLICHT=true, FOTO_MAX=3;
  var eur=new Intl.NumberFormat('nl-NL',{style:'currency',currency:CFG.currency||'EUR'});
  function fmt(c){return eur.format(c/100);}
  function esc(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;');}
  var toast=root.querySelector('[data-toast]'),tt;
  function say(m){if(!toast)return;toast.textContent=m;toast.classList.add('show');clearTimeout(tt);tt=setTimeout(function(){toast.classList.remove('show');},4200);}

  function go(name){
    var panes=root.querySelectorAll('[data-pane]');
    var bestaat=false;
    panes.forEach(function(s){if(s.dataset.pane===name)bestaat=true;});
    if(!bestaat)return;
    panes.forEach(function(s){s.classList.toggle('on',s.dataset.pane===name);});
    root.querySelectorAll('.nav-item').forEach(function(b){b.classList.toggle('active',b.dataset.go===name);});
    window.scrollTo({top:root.offsetTop-20,behavior:'smooth'});
  }

  /* ---------- gegevens uit de databron ---------- */
  var ORDERS=[]; var oel=document.getElementById('glzn-orders');
  if(oel){try{ORDERS=JSON.parse(oel.textContent).filter(function(o){return o.id;});}catch(e){console.warn('GLZN: orders JSON ongeldig',e);}}

  var mel=document.getElementById('glzn-melding-data');
  if(mel){try{
    var MD=JSON.parse(mel.textContent);
    if(MD.meldingUrl)MELD_URL=MD.meldingUrl;
    if(MD.logoUrl)LOGO_URL=MD.logoUrl;
    if(MD.previewUrl)PREVIEW_URL=MD.previewUrl;
    if(MD.email)EMAIL=MD.email;
    if(MD.naam)NAAM=MD.naam;
    var ins=MD.instellingen||{};
    if(ins.werkdagen)WERKDAGEN=parseInt(ins.werkdagen,10)||3;
    if(ins.transit!=null)TRANSIT=parseInt(ins.transit,10)||0;
    if(ins.verzendkosten)VERZEND=parseFloat(String(ins.verzendkosten).replace(',','.'))||0;
    FOTO_VERPLICHT=ins.fotoVerplicht!==false;
    if(ins.fotoMax)FOTO_MAX=parseInt(ins.fotoMax,10)||3;
    var byNaam={};
    (MD.orders||[]).forEach(function(x){if(x.naam)byNaam[x.naam]=x;});
    ORDERS.forEach(function(o){
      var m=byNaam[o.id]; if(!m)return;
      o.oid=m.oid; o.vz=m.vz||'';
      o.items.forEach(function(it,i){
        var r=(m.regels||[])[i]||{};
        it.v=r.v||0;
        it.u=parseFloat(r.u)||1;
      });
    });
  }catch(e){console.warn('GLZN: meldinggegevens ongeldig',e);}}

  /* ---------- openingstijden ---------- */
  (function(){
    var els=root.querySelectorAll('[data-service-status]');
    if(!els.length)return;
    var dagen=String(CFG.serviceDagen||'1,2,3,4,5').split(',').map(function(x){return parseInt(x,10);});
    function mins(s){var p=String(s||'').split(':');return (parseInt(p[0],10)||0)*60+(parseInt(p[1],10)||0);}
    var vanaf=mins(CFG.serviceOpen||'08:30');
    var tot=mins(CFG.serviceDicht||'16:30');
    var dagIdx={Mon:1,Tue:2,Wed:3,Thu:4,Fri:5,Sat:6,Sun:7};
    function nuAms(){
      try{
        var p=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Amsterdam',weekday:'short',hour:'2-digit',minute:'2-digit',hour12:false}).formatToParts(new Date());
        var o={}; p.forEach(function(x){o[x.type]=x.value;});
        return {dag:dagIdx[o.weekday]||0,min:(parseInt(o.hour,10)||0)*60+(parseInt(o.minute,10)||0)};
      }catch(e){
        var d=new Date();
        return {dag:d.getDay()===0?7:d.getDay(),min:d.getHours()*60+d.getMinutes()};
      }
    }
    function upd(){
      var n=nuAms();
      var open=dagen.indexOf(n.dag)>-1&&n.min>=vanaf&&n.min<tot;
      var uren=(CFG.serviceOpen||'08:30')+' tot '+(CFG.serviceDicht||'16:30');
      els.forEach(function(el){
        el.innerHTML='<span class="ga-dot '+(open?'on':'off')+'"></span>'+(open?'Nu open':'Nu gesloten')+' · ma-vr '+uren;
      });
    }
    upd(); setInterval(upd,60000);
  })();

  function rowTotal(r){
    var n=parseInt(r.querySelector('[data-n]').textContent,10);
    var t=r.querySelector('[data-row-total]'); if(t)t.textContent=fmt(n*parseInt(r.dataset.price,10));
    var p=r.querySelector('[data-pcs]'),b=r.querySelector('[data-order-print]');
    if(p&&b)p.textContent=n*parseInt(b.dataset.unit,10);
  }
  function listTotal(l){
    var s=0;
    l.querySelectorAll('[data-prow]').forEach(function(r){s+=parseInt(r.querySelector('[data-n]').textContent,10)*parseInt(r.dataset.price,10);rowTotal(r);});
    var t=l.querySelector('[data-list-total]'); if(t)t.textContent=fmt(s);
  }
  root.querySelectorAll('[data-plist]').forEach(listTotal);
  root.querySelectorAll('[data-prow]').forEach(rowTotal);

  function addItems(items,msg,btn){
    if(!items.length)return; if(btn)btn.disabled=true;
    fetch((CFG.cartUrl||'/cart/add')+'.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){return r.ok?r.json():r.json().then(function(e){throw new Error(e.description||'Toevoegen mislukt');});})
      .then(function(){say(msg);document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));})
      .catch(function(e){say('Let op: '+e.message);})
      .then(function(){if(btn)btn.disabled=false;});
  }

  /* ---------- bedrukken ---------- */
  (function(){
    var pane=root.querySelector('[data-pane="bedrukken"]');
    if(!pane)return;
    var veld=pane.querySelector('[data-druk-zoek]');
    var uit=pane.querySelector('[data-druk-resultaten]');
    var PROEF=pane.dataset.drukProef||'';
    var LEVERTIJD=pane.dataset.drukLevertijd||'';
    var startVrij=parseInt(pane.dataset.drukVrij,10)||0;
    var timer, laatste=null;

    var dlgD=pane.querySelector('#glzn-druk-dlg');
    var kop=dlgD?dlgD.querySelector('[data-druk-kop]'):null;
    var samenvatting=dlgD?dlgD.querySelector('[data-druk-samenvatting]'):null;
    var canvas=dlgD?dlgD.querySelector('[data-druk-canvas]'):null;
    var imgGlas=dlgD?dlgD.querySelector('[data-druk-glas]'):null;
    var imgLogo=dlgD?dlgD.querySelector('[data-druk-logo]'):null;
    var schuif=dlgD?dlgD.querySelector('[data-druk-grootte]'):null;
    var inputBestand=dlgD?dlgD.querySelector('[data-druk-bestand]'):null;
    var bestandsrij=dlgD?dlgD.querySelector('[data-druk-bestandsrij]'):null;
    var bestandsnaam=dlgD?dlgD.querySelector('[data-druk-bestandsnaam]'):null;
    var bestandsnoot=dlgD?dlgD.querySelector('[data-druk-bestandsnoot]'):null;
    var kadernoot=dlgD?dlgD.querySelector('[data-druk-kadernoot]'):null;
    var knopTerug=dlgD?dlgD.querySelector('[data-druk-terug]'):null;
    var knopVerder=dlgD?dlgD.querySelector('[data-druk-verder]'):null;

    var D=null, stap='plaatsen', eigenLogo=null, logoRef='', isKader=false;
    var plaats={x:50,y:42,w:26};

    function vrij(){
      var el=root.querySelector('[data-tegoed]');
      var n=el?parseInt(el.textContent,10):startVrij;
      return isNaN(n)?startVrij:n;
    }

    function kaderAfbeelding(naam){
      var t=String(naam||'jouw logo').slice(0,26).replace(/[<>&]/g,'');
      var svg='<svg xmlns="http://www.w3.org/2000/svg" width="320" height="150">'+
        '<rect x="3" y="3" width="314" height="144" rx="14" fill="rgba(91,82,187,0.10)" stroke="#5B52BB" stroke-width="3" stroke-dasharray="11 9"/>'+
        '<text x="160" y="70" text-anchor="middle" font-family="Helvetica,Arial,sans-serif" font-size="21" font-weight="700" fill="#5B52BB">JOUW LOGO</text>'+
        '<text x="160" y="99" text-anchor="middle" font-family="Helvetica,Arial,sans-serif" font-size="13" fill="#5B52BB">'+t+'</text>'+
        '</svg>';
      return 'data:image/svg+xml;charset=utf-8,'+encodeURIComponent(svg);
    }

    function teken(){
      if(!imgGlas||!imgLogo||!canvas)return;
      var g=imgGlas.getBoundingClientRect(), c=canvas.getBoundingClientRect();
      if(!g.width)return;
      var breedte=g.width*(plaats.w/100);
      imgLogo.style.width=breedte+'px';
      var hoogte=imgLogo.offsetHeight||breedte;
      imgLogo.style.left=((g.left-c.left)+g.width*(plaats.x/100)-breedte/2)+'px';
      imgLogo.style.top=((g.top-c.top)+g.height*(plaats.y/100)-hoogte/2)+'px';
    }

    function toonStap(naam){
      stap=naam;
      dlgD.querySelectorAll('[data-druk-stap]').forEach(function(el){ el.hidden=(el.dataset.drukStap!==naam); });
      if(naam==='plaatsen'){
        imgLogo.classList.toggle('kader',isKader);
        if(kadernoot)kadernoot.hidden=!isKader;
        knopTerug.textContent=(eigenLogo&&!PROEF)?'Ander bestand':'Annuleren';
        knopVerder.textContent='Toevoegen aan winkelwagen';
      } else {
        knopTerug.textContent='Annuleren';
        knopVerder.textContent='Verder';
      }
      knopVerder.disabled=false;
    }

    function zetGlas(src){
      if(!imgGlas||!src)return;
      imgGlas.onload=function(){ teken(); };
      imgGlas.src=src;
      if(imgGlas.complete)setTimeout(teken,30);
    }

    function naarPlaatsen(){
      if(PROEF){ isKader=false; imgLogo.src=PROEF; }
      else if(eigenLogo&&eigenLogo.voorbeeld){ isKader=false; imgLogo.src=eigenLogo.url; }
      else if(eigenLogo){ isKader=true; imgLogo.src=kaderAfbeelding(eigenLogo.naam); }
      else return false;
      toonStap('plaatsen');
      zetGlas(D?D.img:'');
      return true;
    }

    function openVenster(o){
      if(!dlgD)return;
      var glazen=o.dozen*o.per;
      var over=vrij();
      if(glazen>over){ say('Hier heb je '+glazen+' bedrukkingen voor nodig, je hebt er nog '+over+'. Bestel een nieuwe oplage of neem minder dozen.'); return; }
      D={variant:o.variant,dozen:o.dozen,per:o.per,glazen:glazen,titel:o.titel||'',img:o.img||''};
      if(kop)kop.textContent=D.titel||'Je logo op dit glas';
      if(samenvatting)samenvatting.textContent=D.dozen+(D.dozen===1?' doos':' dozen')+' · '+glazen+' glazen · '+glazen+' bedrukkingen van je tegoed';
      plaats={x:50,y:42,w:26};
      if(schuif)schuif.value=26;
      if(!naarPlaatsen())toonStap('upload');
      dlgD.hidden=false;
    }

    function sluitVenster(){ dlgD.hidden=true; D=null; }

    function bevestig(){
      if(!D)return;
      knopVerder.disabled=true; knopVerder.textContent='Bezig…';
      var plaatsing=Math.round(plaats.x)+'% van links, '+Math.round(plaats.y)+'% van boven, breedte '+Math.round(plaats.w)+'%'+(isKader?'. Kader, bestand nog in te zetten':'. Indicatie van de klant');
      var gegevens=D;
      function klaar(ref){
        var props={'Bedrukking':PROEF?'Logo uit tegoed':'Nieuw logo aangeleverd','Levertijd':LEVERTIJD,'Logo plaatsing':plaatsing};
        if(ref)props['Logo referentie']=ref;
        sluitVenster();
        knopVerder.disabled=false;
        knopVerder.textContent='Toevoegen aan winkelwagen';
        addItems([{id:gegevens.variant,quantity:gegevens.dozen,properties:props}],gegevens.glazen+' bedrukte glazen toegevoegd aan je winkelwagen',null);
      }
      if(eigenLogo&&!logoRef&&LOGO_URL){
        fetch(LOGO_URL,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({
          klantEmail:EMAIL, klantNaam:NAAM, glas:gegevens.titel, dozen:gegevens.dozen, glazen:gegevens.glazen,
          plaatsing:plaatsing, bestand:{naam:eigenLogo.naam,type:eigenLogo.type,data:eigenLogo.data}
        })})
        .then(function(r){ return r.ok?r.json():{}; })
        .then(function(d){ logoRef=(d&&d.ref)||''; klaar(logoRef); })
        .catch(function(e){ console.warn('GLZN logo versturen mislukt',e); say('Je logo kon niet worden doorgestuurd. We nemen contact met je op over het ontwerp.'); klaar(''); });
      } else {
        klaar(logoRef);
      }
    }

    if(inputBestand){
      inputBestand.addEventListener('change',function(){
        var f=this.files&&this.files[0];
        if(!f)return;
        if(f.size>10*1024*1024){ say('Dat bestand is groter dan 10 MB. Mail het naar klantenservice@glazen.nl.'); return; }
        var lezer=new FileReader();
        lezer.onload=function(ev){
          var dataUrl=String(ev.target.result);
          eigenLogo={naam:f.name,type:f.type||'application/postscript',data:dataUrl.split(',')[1],url:null,voorbeeld:false};
          logoRef='';
          if(bestandsrij)bestandsrij.hidden=false;
          if(bestandsnaam)bestandsnaam.textContent=f.name;
          if(bestandsnoot)bestandsnoot.textContent='Voorbeeld maken…';
          if(knopVerder)knopVerder.disabled=true;

          function afronden(png,bron){
            if(knopVerder)knopVerder.disabled=false;
            if(png){ eigenLogo.url=png; eigenLogo.voorbeeld=true; }
            if(bestandsnoot){
              if(!png){
                bestandsnoot.textContent='Prima bestand voor drukwerk, maar we konden er geen voorbeeld van maken. Je plaatst zo een kader op de juiste plek.';
              } else if(bron==='direct'){
                bestandsnoot.textContent='Klaar. Je ziet zo hoe dit op je glas staat.';
              } else {
                bestandsnoot.textContent='Voorbeeld gemaakt van je bestand. Je ziet zo hoe dit op je glas staat.';
              }
            }
          }

          if(typeof window.glznLogoVoorbeeld==='function'){
            window.glznLogoVoorbeeld(f,dataUrl,PREVIEW_URL,afronden);
          } else {
            afronden(null,'kader');
          }
        };
        lezer.onerror=function(){ say('Dat bestand kon niet gelezen worden.'); };
        lezer.readAsDataURL(f);
      });
    }

    if(imgLogo){
      var sleept=false, offX=0, offY=0;
      imgLogo.addEventListener('pointerdown',function(e){
        sleept=true; imgLogo.classList.add('pak');
        try{ imgLogo.setPointerCapture(e.pointerId); }catch(err){}
        var r=imgLogo.getBoundingClientRect();
        offX=e.clientX-(r.left+r.width/2);
        offY=e.clientY-(r.top+r.height/2);
        e.preventDefault();
      });
      imgLogo.addEventListener('pointermove',function(e){
        if(!sleept)return;
        var g=imgGlas.getBoundingClientRect();
        if(!g.width)return;
        plaats.x=Math.max(0,Math.min(100,((e.clientX-offX)-g.left)/g.width*100));
        plaats.y=Math.max(0,Math.min(100,((e.clientY-offY)-g.top)/g.height*100));
        teken();
      });
      var los=function(){ sleept=false; imgLogo.classList.remove('pak'); };
      imgLogo.addEventListener('pointerup',los);
      imgLogo.addEventListener('pointercancel',los);
    }

    if(schuif){ schuif.addEventListener('input',function(){ plaats.w=parseFloat(schuif.value)||26; teken(); }); }

    if(dlgD){
      dlgD.addEventListener('click',function(e){
        if(e.target===dlgD||e.target.closest('[data-druk-sluit]')){ sluitVenster(); return; }
        if(e.target.closest('[data-druk-kies]')){ inputBestand.click(); return; }
        var pre=e.target.closest('[data-druk-preset]');
        if(pre){
          var k=pre.dataset.drukPreset;
          if(k==='schenklijn'){ plaats.x=50; plaats.y=36; }
          if(k==='midden'){ plaats.x=50; plaats.y=50; }
          if(k==='reset'){ plaats={x:50,y:42,w:26}; if(schuif)schuif.value=26; }
          teken(); return;
        }
        if(e.target.closest('[data-druk-terug]')){
          if(stap==='plaatsen'&&eigenLogo&&!PROEF){ toonStap('upload'); return; }
          sluitVenster(); return;
        }
        if(e.target.closest('[data-druk-verder]')){
          if(stap==='upload'){
            if(!eigenLogo){ say('Kies eerst een logobestand'); return; }
            naarPlaatsen();
            return;
          }
          bevestig();
        }
      });
      window.addEventListener('resize',function(){ if(!dlgD.hidden&&stap==='plaatsen')teken(); });
      document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!dlgD.hidden)sluitVenster(); });
    }

    /* --- zoeken --- */
    function rij(p){
      var per=parseFloat(p.per)||1;
      var prijs=parseInt(p.prijs,10)||0;
      return '<div class="ga-zoekrij" data-druk-rij data-variant="'+p.id+'" data-per="'+per+'" data-prijs="'+prijs+'" data-glas-img="'+(p.groot||p.img||'')+'" data-glas-titel="'+esc(p.titel)+'">'+
        (p.img?'<div class="thumb photo"><img src="'+p.img+'" alt="" loading="lazy"></div>':'<div class="thumb"><span class="msr">wine_bar</span></div>')+
        '<div class="li-body"><p class="title-sm">'+esc(p.titel)+'</p>'+
        '<p class="body-md muted">'+fmt(prijs)+' per doos van '+per+' · <span data-druk-tel>'+per+'</span> bedrukkingen</p></div>'+
        '<div class="qty"><button type="button" class="state" data-druk-step="-1" aria-label="Minder"><span class="msr" style="font-size:18px">remove</span></button>'+
        '<span class="n" data-druk-n>1</span>'+
        '<button type="button" class="state" data-druk-step="1" aria-label="Meer"><span class="msr" style="font-size:18px">add</span></button></div>'+
        '<span class="price" data-druk-totaal>'+fmt(prijs)+'</span>'+
        '<button type="button" class="btn tonal small state" data-druk-toevoegen>Toevoegen</button>'+
        '</div>';
    }

    function melding(t){ if(uit)uit.innerHTML='<p class="body-md muted" style="padding:16px 4px 4px">'+t+'</p>'; }

    function zoek(){
      var q=veld.value.trim();
      if(q===laatste)return;
      laatste=q;
      if(q.length<2){ uit.innerHTML=''; return; }
      melding('Zoeken…');
      fetch('/search?view=glzn-json&type=product&options[prefix]=last&q='+encodeURIComponent(q))
        .then(function(r){ return r.text(); })
        .then(function(t){
          var data=JSON.parse(t.trim());
          var lijst=data.resultaten||[];
          if(!lijst.length){ melding('Niets gevonden. Probeer een ander woord, of vraag het even aan de klantenservice.'); return; }
          var h='<hr class="div">';
          lijst.forEach(function(p){ if(p&&p.id)h+=rij(p); });
          uit.innerHTML=h;
        })
        .catch(function(e){ console.warn('GLZN zoeken mislukt',e); melding('Zoeken lukte even niet. Probeer het zo nog eens.'); });
    }

    if(veld){ veld.addEventListener('input',function(){ clearTimeout(timer); timer=setTimeout(zoek,320); }); }

    pane.addEventListener('click',function(e){
      if(dlgD&&dlgD.contains(e.target))return;

      var stapKnop=e.target.closest('[data-druk-step]');
      if(stapKnop){
        var r=stapKnop.closest('[data-druk-rij]');
        var n=r.querySelector('[data-druk-n]');
        var w=Math.max(1,parseInt(n.textContent,10)+parseInt(stapKnop.dataset.drukStep,10));
        n.textContent=w;
        var per=parseFloat(r.dataset.per)||1;
        r.querySelector('[data-druk-tel]').textContent=w*per;
        r.querySelector('[data-druk-totaal]').textContent=fmt(w*(parseInt(r.dataset.prijs,10)||0));
        return;
      }

      var zoekKnop=e.target.closest('[data-druk-toevoegen]');
      if(zoekKnop){
        var r2=zoekKnop.closest('[data-druk-rij]');
        openVenster({
          variant:parseInt(r2.dataset.variant,10),
          dozen:parseInt(r2.querySelector('[data-druk-n]').textContent,10)||1,
          per:parseFloat(r2.dataset.per)||1,
          titel:r2.dataset.glasTitel,
          img:r2.dataset.glasImg
        });
        return;
      }

      var vastKnop=e.target.closest('[data-order-print]');
      if(vastKnop){
        e.stopPropagation();
        var r3=vastKnop.closest('[data-prow]');
        var dozen=parseInt(r3.querySelector('[data-n]').textContent,10)||1;
        var perDoos=parseInt(vastKnop.dataset.unit,10)||1;
        var nodig=dozen*perDoos;
        var over=vrij();
        if(nodig>over){
          say('Hier heb je '+nodig+' bedrukkingen voor nodig, je hebt er nog '+over+'. Bestel een nieuwe oplage of neem minder dozen.');
          return;
        }
        addItems([{
          id:parseInt(r3.dataset.variant,10),
          quantity:dozen,
          properties:{
            'Bedrukking':PROEF?'Logo uit tegoed':'Nieuw logo aangeleverd',
            'Levertijd':LEVERTIJD,
            'Logo plaatsing':'Zoals bij de vorige bestelling'
          }
        }], nodig+' bedrukte glazen toegevoegd aan je winkelwagen', vastKnop);
        return;
      }
    });
  })();

  /* ---------- meldtermijn ---------- */
  /* De termijn rekent in Europe/Amsterdam, op dezelfde manier als nuAms bij de
     openingstijden. De tijdzone van het apparaat van de bezoeker mag de meldtermijn
     niet verschuiven. Een kalenderdag houden we bij als UTC-middernacht van de
     Amsterdamse dag, zodat de werkdagentelling geen last heeft van zomertijd. */
  function amsDelen(d){
    try{
      var p=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Amsterdam',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hour12:false}).formatToParts(d);
      var o={}; p.forEach(function(x){o[x.type]=x.value;});
      var u=parseInt(o.hour,10)||0; if(u===24)u=0;
      return {jaar:parseInt(o.year,10),maand:parseInt(o.month,10),dag:parseInt(o.day,10),uur:u,minuut:parseInt(o.minute,10)||0,sec:parseInt(o.second,10)||0};
    }catch(e){
      return {jaar:d.getFullYear(),maand:d.getMonth()+1,dag:d.getDate(),uur:d.getHours(),minuut:d.getMinutes(),sec:d.getSeconds()};
    }
  }
  function amsVerschil(d){
    var p=amsDelen(d);
    return Date.UTC(p.jaar,p.maand-1,p.dag,p.uur,p.minuut,p.sec)-(d.getTime()-d.getMilliseconds());
  }
  function amsDag(d){ var p=amsDelen(d); return new Date(Date.UTC(p.jaar,p.maand-1,p.dag)); }
  function amsEindeDag(dag){
    var gok=Date.UTC(dag.getUTCFullYear(),dag.getUTCMonth(),dag.getUTCDate(),23,59,59,999);
    var t=gok-amsVerschil(new Date(gok));
    return new Date(gok-amsVerschil(new Date(t)));
  }
  /* Leest de verzenddatum. Accepteert +02:00 en het oudere +0200, en valt zonder
     zone terug op Amsterdamse kloktijd. Wat niet te lezen is geeft null, zodat de
     bestaande uitleg het overneemt in plaats van stilzwijgend te verschuiven. */
  function leesDatum(w){
    var s=String(w==null?'':w).trim();
    if(!s)return null;
    var m=s.replace(' ','T').match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?(Z|[+-]\d{2}:?\d{2})?$/);
    if(m){
      var ms=Date.UTC(+m[1],+m[2]-1,+m[3],+m[4],+m[5],+(m[6]||0));
      if(isNaN(ms))return null;
      var z=m[7];
      if(z&&z!=='Z'){
        var zz=z.slice(1).replace(':','');
        ms-=(z.charAt(0)==='-'?-1:1)*((parseInt(zz.slice(0,2),10)*60+parseInt(zz.slice(2),10))*60000);
      } else if(!z){
        ms-=amsVerschil(new Date(ms-amsVerschil(new Date(ms))));
      }
      return new Date(ms);
    }
    var d=new Date(s);
    return isNaN(d.getTime())?null:d;
  }
  function werkdagPlus(start,n){
    var r=new Date(start.getTime()), t=0;
    while(t<n){ r.setUTCDate(r.getUTCDate()+1); var w=r.getUTCDay(); if(w!==0&&w!==6)t++; }
    return r;
  }
  function deadline(o){
    if(!o||!o.vz)return null;
    var vz=leesDatum(o.vz);
    if(!vz)return null;
    return amsEindeDag(werkdagPlus(amsDag(vz),TRANSIT+WERKDAGEN));
  }
  function meldbaar(o){ var d=deadline(o); return !!d && Date.now()<=d.getTime(); }
  function datumNL(d){ return d.toLocaleDateString('nl-NL',{timeZone:'Europe/Amsterdam',day:'numeric',month:'long'}); }
  function meldbareOrders(){ return ORDERS.filter(meldbaar); }

  root.querySelectorAll('[data-claim-open][data-order]').forEach(function(btn){
    var naam=btn.dataset.order;
    var o=ORDERS.filter(function(x){return x.id===naam;})[0];
    if(!o){ btn.dataset.claimUitleg='verlopen'; return; }
    var d=deadline(o);
    if(!d){ btn.dataset.claimUitleg='onderweg'; return; }
    if(!meldbaar(o)){ btn.dataset.claimUitleg='verlopen'; return; }
    var kaart=btn.closest('[data-order-card]');
    if(d&&kaart&&!kaart.querySelector('[data-deadline]')){
      var p=document.createElement('p');
      p.className='body-sm muted ga-deadline';
      p.setAttribute('data-deadline','');
      p.textContent='Schade melden kan tot en met '+datumNL(d)+'.';
      kaart.insertBefore(p,btn.closest('.row'));
    }
  });

  /* ---------- meldingswizard ---------- */
  var dlg=document.getElementById('glzn-dlg');
  var dbody=dlg?dlg.querySelector('[data-claim-body]'):null;
  var C=null;

  if(dlg){
    var dots=dlg.querySelector('.dots');
    if(dots){
      dots.className='ga-steps';
      dots.innerHTML='<div class="ga-steps-bar"><span data-steps-fill></span></div><div class="ga-steps-label"><b data-steps-titel></b><span class="body-sm muted" data-steps-tel></span></div>';
    }
  }

  function ord(){return ORDERS.filter(function(o){return o.id===C.order;})[0];}
  function perGlas(it){ return Math.round(it.p/(parseFloat(it.u)||1)); }
  function maxGlazen(it){ return it.q*(parseFloat(it.u)||1); }
  function glazenCent(){
    var o=ord(); if(!o)return 0;
    var s=0;
    o.items.forEach(function(it,i){ s+=(C.broken[i]||0)*perGlas(it); });
    return s;
  }
  function tegoedCent(){ var b=glazenCent(); return b>0 ? b+Math.round(VERZEND*100) : 0; }
  function aantalGlazen(){ var t=0; for(var k in C.broken){ t+=C.broken[k]||0; } return t; }

  window.glznQty=function(i,d){
    var o=ord();
    C.broken[i]=Math.min(maxGlazen(o.items[i]),Math.max(0,(C.broken[i]||0)+d));
    var el=document.getElementById('gq'+i); if(el)el.textContent=C.broken[i];
  };
  window.__gcKies=function(veld,waarde){
    C[veld]=waarde;
    if(veld==='order')C.broken={};
    setTimeout(volgende,170);
  };

  function stapTitel(){
    if(C.step===1)return 'Wat is er aan de hand?';
    if(C.step===2)return 'Welke bestelling?';
    if(C.step===3)return C.type==='verkeerd'?'Wat klopt er niet?':'Wat is er kapot?';
    return 'Hoe lossen we het op?';
  }
  function stepper(pct,titel,tel){
    var f=dlg.querySelector('[data-steps-fill]');
    var t=dlg.querySelector('[data-steps-titel]');
    var n=dlg.querySelector('[data-steps-tel]');
    if(f)f.style.width=pct+'%';
    if(t)t.textContent=titel;
    if(n)n.textContent=tel;
  }

  function fotoBlok(){
    var h='<p class="title-sm" style="margin-top:18px">Foto van de schade'+(FOTO_VERPLICHT?'':' (optioneel)')+'</p>';
    h+='<p class="body-md muted" style="margin-top:2px">Zo zien we meteen wat er mis is en kunnen we het direct afhandelen.</p>';
    h+='<div class="ga-fotos">';
    C.fotos.forEach(function(f,i){
      h+='<div class="ga-foto"><img src="'+f.url+'" alt=""><button type="button" data-foto-weg="'+i+'" aria-label="Foto verwijderen"><span class="msr">close</span></button></div>';
    });
    if(C.fotos.length<FOTO_MAX){
      h+='<button type="button" class="ga-upload state" data-foto-kies><span class="msr">add_a_photo</span>Foto toevoegen</button>';
    }
    h+='</div><input type="file" id="gFotoInput" accept="image/*" multiple hidden>';
    return h;
  }

  function render(){
    var back=dlg.querySelector('[data-claim-back]');
    var next=dlg.querySelector('[data-claim-next]');

    if(C.done){
      stepper(100,'Melding verstuurd','');
      back.style.visibility='hidden';
      next.textContent='Klaar';
      next.disabled=false;
      var teg=C.solution==='tegoed';
      var vervolg=C.type==='kapot'
        ? (teg?(B2B?'Je ziet de creditering terug op je volgende factuur.':'Zodra wij de foto hebben bekeken staat het tegoed in je account. Meestal dezelfde werkdag.'):'We maken de vervanging klaar en sturen je een track en trace zodra het pakket onderweg is.')
        : (teg?'We controleren de levering en verrekenen het verschil.':'We zoeken uit wat er misgegaan is en sturen de juiste artikelen na.');
      var rijen='<div class="rij"><i>Soort</i><b>'+(C.type==='kapot'?'Breuk':'Verkeerde levering')+'</b></div>';
      rijen+='<div class="rij"><i>Bestelling</i><b>'+esc(C.order)+'</b></div>';
      if(C.type==='kapot'&&aantalGlazen()>0)rijen+='<div class="rij"><i>Gemeld</i><span>'+aantalGlazen()+' glas'+(aantalGlazen()===1?'':'zen')+'</span></div>';
      rijen+='<div class="rij"><i>Oplossing</i><span>'+(teg?(B2B?'Creditering':'Shoptegoed'+(C.type==='kapot'?' van <b>'+fmt(tegoedCent())+'</b>':'')):'Vervanging opsturen')+'</span></div>';
      if(C.fotos.length)rijen+='<div class="rij"><i>Foto\'s</i><span>'+C.fotos.length+' meegestuurd</span></div>';
      dbody.innerHTML='<div class="ga-succes">'+
        '<div class="ga-ring"><span class="msr">check</span></div>'+
        '<h3 class="headline-sm" style="margin-top:14px">Melding ontvangen</h3>'+
        '<p class="body-md muted" style="margin-top:6px">Je krijgt de bevestiging per e-mail op '+esc(EMAIL)+'.</p>'+
        '<div class="ga-sum">'+rijen+'</div>'+
        '<div class="ga-vervolg" style="margin-top:14px"><span class="msr">schedule</span><span>'+vervolg+'</span></div>'+
        '</div>';
      return;
    }

    if(C.error){
      stepper(100,'Versturen lukte niet','');
      back.textContent='Terug';
      back.style.visibility='visible';
      next.textContent='Opnieuw proberen';
      next.disabled=false;
      dbody.innerHTML='<div class="ga-succes">'+
        '<div class="ga-ring" style="background:var(--error-container);color:var(--error)"><span class="msr">error</span></div>'+
        '<h3 class="headline-sm" style="margin-top:14px">Versturen lukte niet</h3>'+
        '<p class="body-md muted" style="margin-top:6px">Er ging iets mis bij het doorgeven van je melding. Probeer het nog een keer, of mail ons op <a href="mailto:klantenservice@glazen.nl">klantenservice@glazen.nl</a>.</p>'+
        '</div>';
      return;
    }

    var lijst = C.step===2 ? meldbareOrders() : null;
    C.leeg = (C.step===2 && !lijst.length);

    stepper(C.leeg?50:C.step*25, C.leeg?'Geen bestellingen om te melden':stapTitel(), C.leeg?'':('Stap '+C.step+' van 4'));
    back.textContent = C.leeg ? 'Sluiten' : 'Terug';
    back.style.visibility = (C.step===1 && !C.leeg) ? 'hidden' : 'visible';
    next.textContent = C.leeg ? 'Contact opnemen' : (C.step===4 ? 'Verstuur melding' : 'Volgende');
    next.disabled=false;
    var h='';

    if(C.step===1){
      h='<label class="choice"><input type="radio" name="gt" value="kapot"'+(C.type==='kapot'?' checked':'')+' onchange="window.__gcKies(\'type\',this.value)"><span class="msr">heart_broken</span><span><span class="title-md">Glas kapot aangekomen</span><br><span class="body-md muted">100% breukvrij bezorgd. Kapot? Je krijgt '+(B2B?'creditering':'shoptegoed')+' of een nieuw glas.</span></span></label>'+
      '<label class="choice"><input type="radio" name="gt" value="verkeerd"'+(C.type==='verkeerd'?' checked':'')+' onchange="window.__gcKies(\'type\',this.value)"><span class="msr">swap_horiz</span><span><span class="title-md">Verkeerde levering</span><br><span class="body-md muted">Ander product, te veel of te weinig ontvangen.</span></span></label>';
    }

    if(C.step===2){
      if(C.leeg){
        h='<div class="card outlined"><p class="title-md">Geen bestellingen om te melden</p>'+
          '<p class="body-md muted" style="margin-top:6px">Schade meld je binnen '+WERKDAGEN+' werkdagen na bezorging. Voor je bestellingen is die termijn verlopen, of ze zijn nog niet bezorgd.</p>'+
          '<p class="body-md muted" style="margin-top:10px">Twijfel je of neem je liever even contact op? Dat kan, we kijken graag met je mee.</p></div>';
      } else {
        lijst.forEach(function(o){
          var d=deadline(o);
          h+='<label class="choice"><input type="radio" name="go" value="'+esc(o.id)+'"'+(C.order===o.id?' checked':'')+' onchange="window.__gcKies(\'order\',this.value)"><span class="msr">package_2</span><span><span class="title-md">'+esc(o.label)+'</span><br><span class="body-md muted">'+esc(o.items.map(function(i){return i.t;}).join(" · ")).slice(0,110)+'</span>'+(d?'<br><span class="body-sm muted">Melden kan tot en met '+datumNL(d)+'</span>':'')+'</span></label>';
        });
      }
    }

    if(C.step===3){
      if(C.type==='kapot'){
        var o3=ord();
        h='<p class="body-md muted" style="margin-bottom:10px">Tel het aantal kapotte glazen, niet het aantal dozen. De rest houd je gewoon.</p>';
        if(o3)o3.items.forEach(function(it,i){
          var pg=perGlas(it);
          h+='<div class="li">'+(it.img?'<div class="thumb photo"><img src="'+it.img+'" alt="" loading="lazy"></div>':'<div class="thumb"><span class="msr">wine_bar</span></div>')+
          '<div class="li-body"><p class="title-sm">'+esc(it.t)+'</p><p class="body-md muted">'+maxGlazen(it)+' glazen ontvangen · '+fmt(pg)+' per glas</p></div>'+
          '<div class="qty"><button type="button" class="state" onclick="glznQty('+i+',-1)"><span class="msr" style="font-size:18px">remove</span></button><span class="n" id="gq'+i+'">'+(C.broken[i]||0)+'</span><button type="button" class="state" onclick="glznQty('+i+',1)"><span class="msr" style="font-size:18px">add</span></button></div></div>';
        });
        h+=fotoBlok();
        h+='<div class="field" style="margin-top:14px"><textarea id="gNote" placeholder="Korte toelichting (optioneel)">'+esc(C.note||'')+'</textarea></div>';
      } else {
        h=['Ander product ontvangen','Te weinig ontvangen','Te veel ontvangen'].map(function(t,i){return '<label class="choice"><input type="radio" name="gi" value="'+t+'"'+(C.issue===t?' checked':'')+' onchange="window.__gc.issue=this.value"><span class="msr">'+['swap_horiz','remove_circle','add_circle'][i]+'</span><span class="title-md">'+t+'</span></label>';}).join('');
        h+=fotoBlok();
        h+='<div class="field" style="margin-top:14px"><textarea id="gNote" placeholder="Korte toelichting (optioneel)">'+esc(C.note||'')+'</textarea></div>';
      }
    }

    if(C.step===4){
      var tegoedLabel=B2B?'Creditering op je volgende factuur':'Shoptegoed';
      if(C.type==='kapot'){
        var glazen=glazenCent(), totaal=tegoedCent(), n=aantalGlazen();
        var uitleg=fmt(glazen)+' voor '+n+' glas'+(n===1?'':'zen')+' + '+fmt(Math.round(VERZEND*100))+' verzendkosten';
        h='<label class="choice aanbevolen"><input type="radio" name="gs" value="tegoed"'+(C.solution==='tegoed'?' checked':'')+' onchange="window.__gc.solution=this.value"><span class="msr">redeem</span><span>'+
          '<span class="ga-badge"><span class="msr">check_circle</span>Meest gekozen</span>'+
          '<span class="title-md" style="display:block;margin-top:8px">'+tegoedLabel+'</span>'+
          '<span class="body-md muted">Meteen geregeld, geen wachten op een pakketje. Je verzendkosten krijg je er bovenop.</span>'+
          '<span class="ga-bedrag"><b>'+fmt(totaal)+'</b><em>'+uitleg+'</em></span>'+
          '<span class="ga-eco"><span class="msr">eco</span><span>Scheelt een extra doos, een rit en verpakkingsmateriaal. Glas is zwaar, dus dat tikt aan.</span></span>'+
          '</span></label>'+
        '<label class="choice"><input type="radio" name="gs" value="nieuw"'+(C.solution==='nieuw'?' checked':'')+' onchange="window.__gc.solution=this.value"><span class="msr">local_shipping</span><span><span class="title-md">Nieuwe glazen opsturen</span><br><span class="body-md muted">Gratis, en het kapotte glas hoef je niet terug te sturen. Wel even wachten op de bezorging.</span></span></label>';
      } else {
        h='<label class="choice"><input type="radio" name="gs" value="nieuw"'+(C.solution==='nieuw'?' checked':'')+' onchange="window.__gc.solution=this.value"><span class="msr">local_shipping</span><span><span class="title-md">Juiste artikelen nasturen</span><br><span class="body-md muted">Inclusief retourlabel voor wat verkeerd kwam.</span></span></label>'+
        '<label class="choice aanbevolen"><input type="radio" name="gs" value="tegoed"'+(C.solution==='tegoed'?' checked':'')+' onchange="window.__gc.solution=this.value"><span class="msr">redeem</span><span>'+
          '<span class="ga-badge"><span class="msr">check_circle</span>Meest gekozen</span>'+
          '<span class="title-md" style="display:block;margin-top:8px">'+(B2B?'Creditering':'Shoptegoed')+' voor het verschil</span>'+
          '<span class="body-md muted">Je houdt wat je ontving; het verschil verrekenen we na controle.</span>'+
          '<span class="ga-eco"><span class="msr">eco</span><span>Geen extra rit en geen retourdoos.</span></span>'+
          '</span></label>';
      }
    }

    dbody.innerHTML=h; window.__gc=C;
  }

  function verkleinFoto(file,cb){
    var reader=new FileReader();
    reader.onload=function(ev){
      var img=new Image();
      img.onload=function(){
        var maxPx=1600;
        var schaal=Math.min(1,maxPx/Math.max(img.width,img.height));
        var cw=Math.round(img.width*schaal), ch=Math.round(img.height*schaal);
        var c=document.createElement('canvas'); c.width=cw; c.height=ch;
        c.getContext('2d').drawImage(img,0,0,cw,ch);
        try{ cb(c.toDataURL('image/jpeg',0.82)); }catch(err){ cb(null); }
      };
      img.onerror=function(){cb(null);};
      img.src=ev.target.result;
    };
    reader.onerror=function(){cb(null);};
    reader.readAsDataURL(file);
  }

  function bewaarNote(){ var n=document.getElementById('gNote'); if(n)C.note=n.value; }
  function sluit(){ dlg.hidden=true; C=null; }

  function uitlegTekst(soort,o){
    if(soort==='onderweg'){
      return {kop:'Nog niet verzonden',tekst:'Je bestelling is nog onderweg naar de verzending. Zodra hij bezorgd is kun je hier schade melden.'};
    }
    var d=o?deadline(o):null;
    var t='Schade meld je binnen '+WERKDAGEN+' werkdagen na bezorging.';
    if(d)t+=' Melden kon tot en met '+datumNL(d)+'.';
    t+=' Voor deze bestelling is die termijn verstreken.';
    return {kop:'Meldtermijn verlopen',tekst:t};
  }

  function toonUitleg(soort,naam){
    var o=ORDERS.filter(function(x){return x.id===naam;})[0];
    var u=uitlegTekst(soort,o);
    C={step:1,type:null,order:null,broken:{},issue:null,solution:null,note:'',fotos:[],done:false,error:false,leeg:false,uitleg:soort};
    var back=dlg.querySelector('[data-claim-back]');
    var next=dlg.querySelector('[data-claim-next]');
    back.style.visibility='hidden';
    next.textContent='Sluiten';
    next.disabled=false;
    stepper(100,u.kop,'');
    dbody.innerHTML='<div class="card outlined">'+
      '<p class="title-md">'+u.kop+'</p>'+
      '<p class="body-md muted" style="margin-top:6px">'+u.tekst+'</p>'+
      '<p class="body-md muted" style="margin-top:10px">Kom je er niet uit, dan kijkt de <a href="'+CONTACT_URL+'">klantenservice</a> graag met je mee.</p>'+
      '</div>';
    dlg.hidden=false;
  }

  function volgende(){
    if(C.uitleg){ sluit(); return; }
    if(C.done){ sluit(); return; }
    if(C.error){C.error=false;return submitClaim();}
    if(C.leeg){ sluit(); go('service'); return; }
    if(C.step===1&&!C.type)return say('Kies eerst wat er aan de hand is');
    if(C.step===2&&!C.order)return say('Kies eerst een bestelling');
    if(C.step===3){
      bewaarNote();
      if(C.type==='kapot'&&aantalGlazen()===0)return say('Geef aan hoeveel glazen kapot zijn');
      if(C.type==='verkeerd'&&!C.issue)return say('Kies eerst wat er niet klopt');
      if(FOTO_VERPLICHT&&!C.fotos.length)return say('Voeg een foto toe, dan zien we direct wat er aan de hand is');
    }
    if(C.step===4){ if(!C.solution)return say('Kies eerst een oplossing'); return submitClaim(); }
    C.step++; render();
  }

  function submitClaim(){
    var o=ord();
    if(!o){say('Kies eerst een bestelling');return;}
    if(!MELD_URL){say('Meldingen zijn nog niet ingesteld. Mail ons op klantenservice@glazen.nl.');return;}
    bewaarNote();

    var items=[];
    if(C.type==='kapot'){
      o.items.forEach(function(it,i){
        var glazen=C.broken[i]||0;
        if(!glazen||!it.v)return;
        var per=parseFloat(it.u)||1;
        items.push({variantId:it.v,aantal:Math.ceil(glazen/per),glazen:glazen,perVerpakking:per,titel:it.t});
      });
    }

    var toel='';
    if(C.type==='verkeerd')toel=C.issue||'';
    if(C.note)toel=toel?(toel+'. '+C.note):C.note;

    var fotos=C.fotos.map(function(f,i){
      return {naam:'melding-'+(i+1)+'.jpg',type:'image/jpeg',data:f.url.split(',')[1]};
    });

    var payload={
      type:C.type,
      oplossing:C.solution==='tegoed'?'tegoed':'vervanging',
      orderId:String(o.oid||''),
      orderNaam:o.id,
      email:EMAIL,
      toelichting:toel,
      bron:'account',
      items:items,
      glazen:aantalGlazen(),
      bedrag:C.type==='kapot'?(tegoedCent()/100).toFixed(2):'',
      bedragGlazen:C.type==='kapot'?(glazenCent()/100).toFixed(2):'',
      verzendkosten:VERZEND.toFixed(2),
      fotos:fotos
    };

    var next=dlg.querySelector('[data-claim-next]');
    next.disabled=true; next.textContent='Versturen...';

    fetch(MELD_URL,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)})
      .then(function(r){if(!r.ok)throw new Error('HTTP '+r.status);return r.json().catch(function(){return {ok:true};});})
      .then(function(){C.done=true;C.error=false;render();})
      .catch(function(e){console.warn('GLZN melding mislukt',e);C.error=true;render();});
  }

  root.addEventListener('click',function(e){
    var t=e.target;

    var dt=t.closest('[data-detail-toggle]');
    if(dt){
      var kaart=dt.closest('[data-order-card]');
      var det=kaart?kaart.querySelector('[data-detail]'):null;
      if(det){det.hidden=!det.hidden;dt.textContent=det.hidden?'Details':'Verberg details';}
      return;
    }

    var ai=t.closest('[data-ai-open]');
    if(ai){
      var launcher=document.querySelector('[data-shoply-chat],.shoply-chat-launcher,#shoply-chat-launcher');
      if(launcher){e.preventDefault();launcher.click();}
      return;
    }

    if(t.closest('[data-order-print]')||t.closest('[data-druk-toevoegen]'))return;

    var nav=t.closest('[data-go]'); if(nav){go(nav.dataset.go);return;}
    var step=t.closest('[data-step]');
    if(step){var r=step.closest('[data-prow]');var n=r.querySelector('[data-n]');n.textContent=Math.max(1,parseInt(n.textContent,10)+parseInt(step.dataset.step,10));var l=step.closest('[data-plist]');l?listTotal(l):rowTotal(r);return;}
    var ro=t.closest('[data-add-items]'); if(ro){addItems(JSON.parse(ro.dataset.addItems),'Toegevoegd aan je winkelwagen',ro);return;}
    var lb=t.closest('[data-order-list]');
    if(lb){var items=[].map.call(lb.closest('[data-plist]').querySelectorAll('[data-prow]'),function(r){return{id:parseInt(r.dataset.variant,10),quantity:parseInt(r.querySelector('[data-n]').textContent,10)};});addItems(items,'Lijst "'+lb.dataset.listName+'" staat in je winkelwagen',lb);return;}
    var op=t.closest('[data-claim-open]');
    if(op&&dlg){
      if(op.dataset.claimUitleg){ toonUitleg(op.dataset.claimUitleg,op.dataset.order||''); return; }
      var mlijst=meldbareOrders();
      var gevraagd=op.dataset.order||'';
      var start=null;
      mlijst.forEach(function(x){ if(x.id===gevraagd)start=x.id; });
      if(!start&&mlijst.length===1)start=mlijst[0].id;
      C={step:1,type:null,order:start,broken:{},issue:null,solution:null,note:'',fotos:[],done:false,error:false,leeg:false};
      dlg.hidden=false; render(); return;
    }
  });

  if(dlg){
    dlg.addEventListener('click',function(e){
      if(e.target===dlg||e.target.closest('[data-claim-close]')){ sluit(); return; }
      var weg=e.target.closest('[data-foto-weg]');
      if(weg){ C.fotos.splice(parseInt(weg.dataset.fotoWeg,10),1); render(); return; }
      if(e.target.closest('[data-foto-kies]')){ var inp=document.getElementById('gFotoInput'); if(inp)inp.click(); return; }
      if(e.target.closest('[data-claim-back]')){
        if(C.uitleg){ sluit(); return; }
        if(C.leeg){ sluit(); return; }
        if(C.error){C.error=false;render();return;}
        if(C.step>1){bewaarNote();C.step--;render();}
        return;
      }
      if(e.target.closest('[data-claim-next]')){ volgende(); }
    });

    dlg.addEventListener('change',function(e){
      if(e.target.id!=='gFotoInput')return;
      var files=[].slice.call(e.target.files||[]);
      if(!files.length)return;
      var ruimte=FOTO_MAX-C.fotos.length;
      if(files.length>ruimte){ say('Je kunt maximaal '+FOTO_MAX+' foto\'s meesturen'); files=files.slice(0,ruimte); }
      bewaarNote();
      var teDoen=files.length;
      files.forEach(function(f){
        verkleinFoto(f,function(url){
          if(url)C.fotos.push({url:url});
          teDoen--;
          if(teDoen===0)render();
        });
      });
    });

    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&C){sluit();}});
  }

  root.addEventListener('pointerdown',function(e){
    var el=e.target.closest('.state'); if(!el)return;
    if(el.closest('[data-druk-canvas]'))return;
    var r=el.getBoundingClientRect(), ink=document.createElement('span'), size=Math.max(r.width,r.height);
    ink.className='ripple-ink'; ink.style.width=ink.style.height=size+'px';
    ink.style.left=(e.clientX-r.left-size/2)+'px'; ink.style.top=(e.clientY-r.top-size/2)+'px';
    if(getComputedStyle(el).position==='static')el.style.position='relative';
    el.appendChild(ink); setTimeout(function(){ink.remove();},600);
  });
})();